import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  clear() {
    this.element.append(this.clearElement)
    this.element.requestSubmit();
  }

  get clearElement() {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = 'clear'
    input.value = true

    return input
  }
}
